export default __webpack_public_path__ + "static/media/CadastroAcessoIconBlue.087c0edd.svg";